import {
    FETCH_ALGORITHM, FETCH_ALGORITHM_SUCCESS, FETCH_ALGORITHM_FAILURE,
    SAVE_ALGORITHM, SAVE_ALGORITHM_SUCCESS, SAVE_ALGORITHM_FAILURE,
    EMPTY_ALGORITHM, SET_ALGORITHM
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const emptyAlgorithm = () => ({
    type: EMPTY_ALGORITHM
});

const fetchAlgorithm = () => ({
    type: FETCH_ALGORITHM
});

const fetchAlgorithmSuccess = (data) => ({
    type: FETCH_ALGORITHM_SUCCESS,
    data
});

const fetchAlgorithmFailure = (error) => ({
    type: FETCH_ALGORITHM_FAILURE,
    error
});

const saveAlgorithm = () => ({
    type: SAVE_ALGORITHM
});

const saveAlgorithmSuccess = (data) => ({
    type: SAVE_ALGORITHM_SUCCESS,
    data
});

const saveAlgorithmFailure = (error) => ({
    type: SAVE_ALGORITHM_FAILURE,
    error
});

export const setAlgorithm = (data) => ({
    type: SET_ALGORITHM,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getAlgorithm = () => (dispatch, getStore) => {
    console.log('GET-ing algorithm config');

    dispatch(fetchAlgorithm());

    return request(PATHS.algorithm.get(), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            dispatch(fetchAlgorithmSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error getting algorithm', error);
            error.friendlyMessage = 'There was an error getting your configuration. Please try again.';
            dispatch(fetchAlgorithmFailure(error));
            return error;
        });
};

export const putAlgorithm = () => (dispatch, getStore) => {
    console.log('PUT-ing algorithm config');

    dispatch(saveAlgorithm());

    let algorithm = getStore().algorithm.config;

    return request(PATHS.algorithm.save(algorithm.id), requestConfig('PUT', algorithm, getStore().auth.token))
        .then((response) => {
            console.log('saved algorithm', response);
            dispatch(saveAlgorithmSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error saving algorithm', error);
            error.friendlyMessage = 'There was an error saving your configuration. Please try again.';
            dispatch(saveAlgorithmFailure(error));
            return error;
        });
}



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/store/actions.js